import { useToast } from '@melio/penny';
import { forwardRef } from '@melio/platform-utils';

import { AddCardScreen } from './screens';
import { useAddCardFundingSource } from './useAddCardFundingSource';

export type AddCardFundingSourceActivityProps = {
  onBack?: VoidFunction;
  onError?: ErrorFunction;
  onDone: (id: string) => unknown;
  onClose?: VoidFunction;
  billId?: string;
};

export const AddCardFundingSourceActivity = forwardRef<AddCardFundingSourceActivityProps>(
  ({ onDone, onBack, onError: _onError, billId, ...props }, ref) => {
    const toast = useToast();

    const onError: ErrorFunction = (error) => {
      toast({ type: 'error', title: error.message });
      _onError?.(error);
    };

    const { isCreating, onSubmit } = useAddCardFundingSource({
      onError,
      onCardHolderSuccess: ({ id }) => onDone(id),
    });

    return (
      <AddCardScreen billId={billId} onBack={onBack} onSubmit={onSubmit} isSaving={isCreating} {...props} ref={ref} />
    );
  }
);
AddCardFundingSourceActivity.displayName = 'AddCardFundingSourceActivity';
